import React, { useEffect, useState } from "react";
import moment from "moment";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useTranslation } from "react-i18next";
import { mockRankTimeRecord } from "../../../utils/mockData";
import { Box, MenuItem, Typography } from "@mui/material";
import { ButtonOutlined } from "../../../components/button/ButtonCustoms";
import CustomerCard from "./components/CustomerCard";
import { icons } from "../../../assets/icons/icons";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { NavigateFunction, useNavigate } from "react-router-dom";
import InputTextField from "../../../components/input/inputTextField";
import { SearchOutlined } from "@mui/icons-material";
import FilterSelect from "../../../components/select/filterSelect";
import { workScheduleApi } from "../../../api/work-schedule/work-schedule.api";
import { OrganizationApi } from "../../../api/organization/organization.api";
import { PositionApi } from "../../../api/position/position.api";
import { debouncedApiCall } from "../../../utils/app.utils";

type Props = {};

const TimeRecordSystemAll: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [dataTimeRecord, setDataTimeRecord] = useState([]);
  const [dataRankingTimeRecord, setDataRankingTimeRecord] = useState<any>([]);
  const [search, setSearch] = useState<string>("");
  const [inputValueSearch, setInputValueSearch] = useState({
    name: "",
    position: "",
    department: "",
  });

  const [dataPosition, setDataPosition] = useState([]);
  const [dataDepartment, setDataDepartment] = useState([]);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(
    dataTimeRecord && dataTimeRecord.length
  );
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: t("อันดับ"),
    },
    {
      id: "employee_name",
      width: 50,
      disablePadding: false,
      align: "start",
      label: t("ชื่อนาม-สกุล"),
    },
    {
      id: "employee_no",
      disablePadding: false,
      width: 75,
      align: "center",
      label: t("เลขประจำตัวเจ้าหน้าที่"),
    },
    {
      id: "nickname",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("ฉายา"),
    },
    {
      id: "position",
      disablePadding: false,
      align: "center",
      width: 40,
      label: t("ตำแหน่งงาน"),
    },
    {
      id: "department",
      disablePadding: false,
      align: "center",
      width: 40,
      label: t("หน่วยงาน"),
    },
    {
      id: "percent",
      disablePadding: false,
      align: "center",
      width: 40,
      label: t("เปอร์เซ็นต์การเข้าออกงาน (%)"),
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_employee,
      employee_no,
      first_name,
      buddhist_name,
      last_name,
      position_name,
      department_name_th,
      percent_work_in_out,
    } = objData;

    const objRenderData = {
      key: id_employee,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${first_name + " " + last_name}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: employee_no || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: buddhist_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: position_name,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: department_name_th || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: percent_work_in_out || 0,
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  // Define rank and employee data
  const rankArray = [
    { rank: 1, rank_name: t("อันดับ 1"), color: "#FCAF17" },
    { rank: 2, rank_name: t("อันดับ 2"), color: "#828282" },
    { rank: 3, rank_name: t("อันดับ 3"), color: "#E37F22" },
    { rank: 4, rank_name: t("อันดับ 4"), color: "#4A4A4A" },
  ];

  const getAllEmployeeTimeRecord = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      id_position: inputValueSearch.position,
      id_department: inputValueSearch.department,
    };

    if (search) query = { ...query, search: search };

    const res = await workScheduleApi.getAllTimeRecord(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
      setDataTimeRecord(data.data.items);
    } else {
      setDataTimeRecord([]);
    }
  };

  const fetchGetRankingTimeRecord = async () => {
    const param = {
      limit: 20,
    };
    const res = await workScheduleApi.getRankEmployee(param);
    const data = res.data;
    if (data.status < 300 && data.data && data.data?.items.length > 0) {
      setDataRankingTimeRecord(data.data.items);
    } else {
      setDataRankingTimeRecord([]);
    }
  };

  const fetchGetPositions = async () => {
    const param = {
      limit: 100,
    };
    const res = await PositionApi.list(param);
    const data = res.data;
    if (data.status < 300 && data.data && data.data?.items.length > 0) {
      setDataPosition(data.data.items);
    } else {
      setDataPosition([]);
    }
  };

  const fetchGetDepartments = async () => {
    const param = {
      keyword: "",
      limit: 100,
    };
    const res = await OrganizationApi.list(param);
    const data = res.data;
    if (data.status < 300 && data.data) {
      setDataDepartment(data.data);
    } else {
      setDataDepartment([]);
    }
  };

  useEffect(() => {
    getAllEmployeeTimeRecord();
    fetchGetRankingTimeRecord();
    fetchGetPositions();
    fetchGetDepartments();
  }, []);

  useEffect(() => {
    getAllEmployeeTimeRecord();
  }, [page, pageLimit, sortBy, sortType, inputValueSearch, search]);

  return (
    <div>
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("ระบบบันทึกเวลาปฏิบัติงาน"),
            key: "1",
            pathName: routeName.cms.TimeRecordSystem,
          },
          {
            name: t("อันดับการเข้าออกงานทั้งหมด"),
            key: "2",
            pathName: routeName.cms.TimeRecordSystem + `/all`,
          },
        ]}
      />

      <section className="my-4">
        <Typography variant="h3">{t("อันดับการเข้าออกงานทั้งหมด")}</Typography>
      </section>

      <section className="my-4">
        <Box
          sx={{
            display: "flex",
            gap: 2, // Adjust spacing between cards
            justifyContent: "center", // Center align horizontally
          }}
        >
          {dataRankingTimeRecord
            .slice(0, 4)
            .map((employee: any, index: number) => {
              const rank = rankArray[employee.rank - 1]; // Get rank based on index
              return (
                <CustomerCard
                  key={employee.id}
                  headerColor={rank.color}
                  headerText={rank.rank_name}
                  rank={employee?.rank}
                  position_name={employee?.position_name || ""}
                  department_name={employee?.department_name_th || employee?.department_name_eng || ""}
                  imageUrl={
                    employee.file_path
                      ? process.env.REACT_APP_FILE_BASE_API +
                      "/" +
                      employee.file_path
                      : icons.profile
                  }
                  customerName={
                    employee.title +
                    " " +
                    employee.first_name +
                    " " +
                    employee.last_name
                  }
                  position={employee.position ?? ""}
                  department={employee.department ?? ""}
                />
              );
            })}
        </Box>
      </section>

      <section className="my-4"></section>

      <section className="my-4">
        <Typography variant="h5">{t("อันดับการเข้าออกงานทั้งหมด")}</Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full sm:col-span-12 md:col-span-3 lg:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อ - นามสกุล/ชื่อฉายา")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="sm:col-span-12 md:col-span-3 lg:col-span-3">
          <FilterSelect
            value={inputValueSearch.position ?? ""}
            // renderValue={() => "ทุกหลักสูตร"}
            labelId="position-id"
            selectId="position-select-id"
            options={[
              {
                id_position: "",
                position_name: t("ทุกตำแหน่งงาน"),
              },
              ...dataPosition,
            ].map((list, index) => (
              <MenuItem value={list.id_position} key={index + 1}>
                {list.position_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("position", e.target.value)
            }
          />
        </article>
        <article className="sm:col-span-12 md:col-span-3 lg:col-span-3">
          <FilterSelect
            value={inputValueSearch.department ?? ""}
            // renderValue={() => "ทุกสถานะ"}
            labelId="department-id"
            selectId="department-select-id"
            options={[
              {
                id_department: "",
                department_name_th: t("ทุกหน่วยงาน"),
              },
              ...dataDepartment,
            ].map((list, index) => (
              <MenuItem value={list.id_department} key={index + 1}>
                {list.department_name_th}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("department", e.target.value)
            }
          />
        </article>
      </div>
      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataTimeRecord &&
            dataTimeRecord.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <section
        className="my-4"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.TimeRecordSystem);
          }}
          mode="del"
          buttonName={t("ย้อนกลับ")}
          btnProps={{
            width: "100px",
          }}
        />
      </section>
    </div>
  );
};

export default TimeRecordSystemAll;
